import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import type { Timestamp } from '@google-cloud/firestore'

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Timestamp: Timestamp;
};

export type Activity = {
  __typename?: 'Activity';
  address: Scalars['String'];
  addressLink?: Maybe<Scalars['String']>;
  catalanLevel: Scalars['String'];
  category: Scalars['String'];
  city: Scalars['String'];
  closingDate: Scalars['String'];
  date: Scalars['String'];
  description: Scalars['String'];
  duration: Scalars['String'];
  id: Scalars['ID'];
  openingDate: Scalars['String'];
  pairings?: Maybe<Array<Maybe<Pairing>>>;
  province: Scalars['String'];
  registrations?: Maybe<Array<Maybe<Registration>>>;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  venue: Scalars['String'];
  video?: Maybe<Scalars['String']>;
};


export type ActivityPairingsArgs = {
  input?: Maybe<PairingFilterInput>;
};


export type ActivityRegistrationsArgs = {
  input?: Maybe<RegistrationFilterInput>;
};

export type ContactMessage = {
  __typename?: 'ContactMessage';
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
};

export type DeletePairingResponse = {
  __typename?: 'DeletePairingResponse';
  activity?: Maybe<Activity>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  autoPair?: Maybe<Activity>;
  createPairing?: Maybe<PairingResponse>;
  createRegistration: Registration;
  deletePairing?: Maybe<DeletePairingResponse>;
  invalidateRegistration?: Maybe<Registration>;
  sendAllPairingEmails?: Maybe<Activity>;
  sendContactMessage?: Maybe<ContactMessage>;
  sendPairingEmail?: Maybe<Pairing>;
  subscribeToNewsletter?: Maybe<NewsletterSubscription>;
  updateRegistration: Registration;
  validateRegistration?: Maybe<Registration>;
  waitlistRegistration?: Maybe<Registration>;
  waitlistRegistrationsInActivity?: Maybe<Activity>;
};


export type MutationAutoPairArgs = {
  activityId: Scalars['ID'];
};


export type MutationCreatePairingArgs = {
  input?: Maybe<PairingInput>;
};


export type MutationCreateRegistrationArgs = {
  data?: Maybe<CreateRegistrationInput>;
};


export type MutationDeletePairingArgs = {
  id: Scalars['ID'];
};


export type MutationInvalidateRegistrationArgs = {
  id: Scalars['ID'];
};


export type MutationSendAllPairingEmailsArgs = {
  activityId: Scalars['ID'];
};


export type MutationSendContactMessageArgs = {
  data?: Maybe<SendContactMessageInput>;
};


export type MutationSendPairingEmailArgs = {
  pairingId: Scalars['ID'];
};


export type MutationSubscribeToNewsletterArgs = {
  email: Scalars['String'];
};


export type MutationUpdateRegistrationArgs = {
  data?: Maybe<UpdateRegistrationInput>;
};


export type MutationValidateRegistrationArgs = {
  id: Scalars['ID'];
};


export type MutationWaitlistRegistrationArgs = {
  registrationId: Scalars['ID'];
};


export type MutationWaitlistRegistrationsInActivityArgs = {
  activityId: Scalars['ID'];
};

export type NewsletterSubscription = {
  __typename?: 'NewsletterSubscription';
  created: Scalars['Timestamp'];
  email: Scalars['String'];
  id: Scalars['ID'];
  updated: Scalars['Timestamp'];
};

export type Pairing = {
  __typename?: 'Pairing';
  activity?: Maybe<Activity>;
  created: Scalars['Timestamp'];
  emailSent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  learnerRegistration: Registration;
  teacherRegistration: Registration;
  updated: Scalars['Timestamp'];
};


export type PairingActivityArgs = {
  activityId?: Maybe<Scalars['ID']>;
};

export type PairingInput = {
  activityId: Scalars['ID'];
  learnerRegistrationId: Scalars['ID'];
  teacherRegistrationId: Scalars['ID'];
};

export type PairingResponse = {
  __typename?: 'PairingResponse';
  activity?: Maybe<Activity>;
  id?: Maybe<Scalars['ID']>;
};

export type Query = {
  __typename?: 'Query';
  activity?: Maybe<Activity>;
  pairing?: Maybe<Pairing>;
  pairings?: Maybe<Array<Maybe<Pairing>>>;
  registration?: Maybe<Registration>;
  registrations?: Maybe<Array<Maybe<Registration>>>;
  registrationsForActivity?: Maybe<Scalars['Int']>;
  subscriptions?: Maybe<Array<Maybe<NewsletterSubscription>>>;
};


export type QueryActivityArgs = {
  activityId: Scalars['ID'];
};


export type QueryPairingArgs = {
  id: Scalars['ID'];
};


export type QueryRegistrationArgs = {
  id: Scalars['ID'];
};


export type QueryRegistrationsForActivityArgs = {
  activityId: Scalars['String'];
  userRole?: Maybe<Scalars['String']>;
};

export type Registration = {
  __typename?: 'Registration';
  activity: Scalars['String'];
  birthYear: Scalars['Int'];
  city: Scalars['String'];
  created: Scalars['Timestamp'];
  email: Scalars['String'];
  gender: GenderType;
  id: Scalars['ID'];
  /** Is enrolled in Language Volunteering */
  isLanguageVolunteer: Scalars['Boolean'];
  /** Is member of Omnium Cutural */
  isMember: Scalars['Boolean'];
  /** Has registration been confirmed */
  isValid?: Maybe<Scalars['Boolean']>;
  /** Has been sent a waitlist email confirmation */
  isWaitlisted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  province: Scalars['String'];
  surname: Scalars['String'];
  teacherGender?: Maybe<Array<GenderType>>;
  /** Registration confirmation token */
  token?: Maybe<Scalars['String']>;
  /** Is learner or volunteer */
  type: RegistrationType;
  unsubscriptionToken?: Maybe<Scalars['String']>;
  updated: Scalars['Timestamp'];
};

export type CreateRegistrationInput = {
  activity: Scalars['String'];
  birthYear: Scalars['Int'];
  city: Scalars['String'];
  email: Scalars['String'];
  gender: GenderType;
  /** Is enrolled in Language Volunteering? */
  isLanguageVolunteer: Scalars['Boolean'];
  /** Is member of Omnium Cutural? */
  isMember: Scalars['Boolean'];
  isWaitlisted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  province: Scalars['String'];
  surname: Scalars['String'];
  /** What genre does user want to be paired with? */
  teacherGender?: Maybe<Array<GenderType>>;
  /** Is learner or volunteer */
  type: RegistrationType;
};

export enum GenderType {
  Dona = 'Dona',
  Home = 'Home',
  NoBinari = 'NoBinari'
}

export type PairingFilterInput = {
  activityId?: Maybe<Scalars['String']>;
};

export type RegistrationFilterInput = {
  activityId?: Maybe<Scalars['String']>;
  /** Is available for pairing? */
  available?: Maybe<Scalars['Boolean']>;
  isValid?: Maybe<Scalars['Boolean']>;
  isWaitlisted?: Maybe<Scalars['Boolean']>;
  type?: Maybe<RegistrationType>;
};

export enum RegistrationType {
  Learner = 'learner',
  Volunteer = 'volunteer'
}

export type SendContactMessageInput = {
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
};

export type UpdateRegistrationInput = {
  birthYear: Scalars['Int'];
  city: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  /** Is enrolled in Language Volunteering? */
  isLanguageVolunteer: Scalars['Boolean'];
  /** Is member of Omnium Cutural? */
  isMember: Scalars['Boolean'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  province: Scalars['String'];
  surname: Scalars['String'];
  /** Is learner or volunteer */
  type: RegistrationType;
};

export type AutoPairMutationVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type AutoPairMutation = { __typename?: 'Mutation', autoPair?: { __typename?: 'Activity', id: string, category: string, venue: string, date: string, title: string, teacherRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, learnerRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, pairings?: Array<{ __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type CreatePairingMutationVariables = Exact<{
  learnerRegistrationId: Scalars['ID'];
  teacherRegistrationId: Scalars['ID'];
  activityId: Scalars['ID'];
}>;


export type CreatePairingMutation = { __typename?: 'Mutation', createPairing?: { __typename?: 'PairingResponse', activity?: { __typename?: 'Activity', id: string, category: string, venue: string, date: string, title: string, teacherRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, learnerRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, pairings?: Array<{ __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type CreateRegistrationMutationVariables = Exact<{
  createRegistrationData?: Maybe<CreateRegistrationInput>;
}>;


export type CreateRegistrationMutation = { __typename?: 'Mutation', createRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined } };

export type DeletePairingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePairingMutation = { __typename?: 'Mutation', deletePairing?: { __typename?: 'DeletePairingResponse', success?: boolean | null | undefined, activity?: { __typename?: 'Activity', id: string, category: string, venue: string, date: string, title: string, teacherRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, learnerRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, pairings?: Array<{ __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type InvalidateRegistrationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvalidateRegistrationMutation = { __typename?: 'Mutation', invalidateRegistration?: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined };

export type SendAllPairingEmailsMutationVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type SendAllPairingEmailsMutation = { __typename?: 'Mutation', sendAllPairingEmails?: { __typename?: 'Activity', id: string, category: string, venue: string, date: string, title: string, teacherRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, learnerRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, pairings?: Array<{ __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type SendContactMessageMutationMutationVariables = Exact<{
  sendContactMessageData?: Maybe<SendContactMessageInput>;
}>;


export type SendContactMessageMutationMutation = { __typename?: 'Mutation', sendContactMessage?: { __typename?: 'ContactMessage', name: string, surname: string, email: string, phone?: string | null | undefined, message: string } | null | undefined };

export type SendPairingEmailMutationVariables = Exact<{
  pairingId: Scalars['ID'];
}>;


export type SendPairingEmailMutation = { __typename?: 'Mutation', sendPairingEmail?: { __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined };

export type SubscribeToNewsletterMutationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SubscribeToNewsletterMutationMutation = { __typename?: 'Mutation', subscribeToNewsletter?: { __typename?: 'NewsletterSubscription', id: string, email: string, created: Timestamp, updated: Timestamp } | null | undefined };

export type UpdateRegistrationMutationVariables = Exact<{
  updateRegistrationData?: Maybe<UpdateRegistrationInput>;
}>;


export type UpdateRegistrationMutation = { __typename?: 'Mutation', updateRegistration: { __typename?: 'Registration', type: RegistrationType, id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, activity: string, birthYear: number, isLanguageVolunteer: boolean, isMember: boolean, province: string, city: string } };

export type ValidateRegistrationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ValidateRegistrationMutation = { __typename?: 'Mutation', validateRegistration?: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined };

export type WaitlistRegistrationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WaitlistRegistrationMutation = { __typename?: 'Mutation', waitlistRegistration?: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined };

export type WaitlistRegistrationsInActivityMutationVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type WaitlistRegistrationsInActivityMutation = { __typename?: 'Mutation', waitlistRegistrationsInActivity?: { __typename?: 'Activity', id: string, category: string, venue: string, date: string, title: string, teacherRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, learnerRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, pairings?: Array<{ __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type ActivityFragment = { __typename?: 'Activity', id: string, category: string, venue: string, date: string, title: string, teacherRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, learnerRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, pairings?: Array<{ __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined> | null | undefined };

export type PairingFragment = { __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } };

export type RegistrationFragment = { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined };

export type AllRegistrationsQueryVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type AllRegistrationsQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', id: string, registrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetActivityQueryVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type GetActivityQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', id: string, category: string, venue: string, date: string, title: string, teacherRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, learnerRegistrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined, pairings?: Array<{ __typename?: 'Pairing', id: string, emailSent?: boolean | null | undefined, teacherRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined }, learnerRegistration: { __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type GetNumberOfRegistrationsForActivityQueryVariables = Exact<{
  activityId: Scalars['String'];
  userRole?: Maybe<Scalars['String']>;
}>;


export type GetNumberOfRegistrationsForActivityQuery = { __typename?: 'Query', registrationsForActivity?: number | null | undefined };

export type GetRegistrationQueryVariables = Exact<{
  registrationId: Scalars['ID'];
}>;


export type GetRegistrationQuery = { __typename?: 'Query', registration?: { __typename?: 'Registration', id: string, type: RegistrationType, activity: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, isWaitlisted?: boolean | null | undefined } | null | undefined };

export type GetRegistrationsQueryVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type GetRegistrationsQuery = { __typename?: 'Query', activity?: { __typename?: 'Activity', registrations?: Array<{ __typename?: 'Registration', id: string, name: string, surname: string, email: string, phone: string, gender: GenderType, teacherGender?: Array<GenderType> | null | undefined, province: string, city: string, birthYear: number, isMember: boolean, isLanguageVolunteer: boolean, created: Timestamp, updated: Timestamp, activity: string, type: RegistrationType, isValid?: boolean | null | undefined, isWaitlisted?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Activity: ResolverTypeWrapper<Activity>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  ContactMessage: ResolverTypeWrapper<ContactMessage>;
  DeletePairingResponse: ResolverTypeWrapper<DeletePairingResponse>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Mutation: ResolverTypeWrapper<{}>;
  NewsletterSubscription: ResolverTypeWrapper<NewsletterSubscription>;
  Pairing: ResolverTypeWrapper<Pairing>;
  PairingInput: PairingInput;
  PairingResponse: ResolverTypeWrapper<PairingResponse>;
  Query: ResolverTypeWrapper<{}>;
  Registration: ResolverTypeWrapper<Registration>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Timestamp: ResolverTypeWrapper<Scalars['Timestamp']>;
  createRegistrationInput: CreateRegistrationInput;
  genderType: GenderType;
  pairingFilterInput: PairingFilterInput;
  registrationFilterInput: RegistrationFilterInput;
  registrationType: RegistrationType;
  sendContactMessageInput: SendContactMessageInput;
  updateRegistrationInput: UpdateRegistrationInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Activity: Activity;
  Boolean: Scalars['Boolean'];
  ContactMessage: ContactMessage;
  DeletePairingResponse: DeletePairingResponse;
  ID: Scalars['ID'];
  Int: Scalars['Int'];
  Mutation: {};
  NewsletterSubscription: NewsletterSubscription;
  Pairing: Pairing;
  PairingInput: PairingInput;
  PairingResponse: PairingResponse;
  Query: {};
  Registration: Registration;
  String: Scalars['String'];
  Timestamp: Scalars['Timestamp'];
  createRegistrationInput: CreateRegistrationInput;
  pairingFilterInput: PairingFilterInput;
  registrationFilterInput: RegistrationFilterInput;
  sendContactMessageInput: SendContactMessageInput;
  updateRegistrationInput: UpdateRegistrationInput;
};

export type ActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Activity'] = ResolversParentTypes['Activity']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  catalanLevel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  closingDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  openingDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pairings?: Resolver<Maybe<Array<Maybe<ResolversTypes['Pairing']>>>, ParentType, ContextType, RequireFields<ActivityPairingsArgs, never>>;
  province?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  registrations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Registration']>>>, ParentType, ContextType, RequireFields<ActivityRegistrationsArgs, never>>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  venue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactMessage'] = ResolversParentTypes['ContactMessage']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletePairingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePairingResponse'] = ResolversParentTypes['DeletePairingResponse']> = {
  activity?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  autoPair?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType, RequireFields<MutationAutoPairArgs, 'activityId'>>;
  createPairing?: Resolver<Maybe<ResolversTypes['PairingResponse']>, ParentType, ContextType, RequireFields<MutationCreatePairingArgs, never>>;
  createRegistration?: Resolver<ResolversTypes['Registration'], ParentType, ContextType, RequireFields<MutationCreateRegistrationArgs, never>>;
  deletePairing?: Resolver<Maybe<ResolversTypes['DeletePairingResponse']>, ParentType, ContextType, RequireFields<MutationDeletePairingArgs, 'id'>>;
  invalidateRegistration?: Resolver<Maybe<ResolversTypes['Registration']>, ParentType, ContextType, RequireFields<MutationInvalidateRegistrationArgs, 'id'>>;
  sendAllPairingEmails?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType, RequireFields<MutationSendAllPairingEmailsArgs, 'activityId'>>;
  sendContactMessage?: Resolver<Maybe<ResolversTypes['ContactMessage']>, ParentType, ContextType, RequireFields<MutationSendContactMessageArgs, never>>;
  sendPairingEmail?: Resolver<Maybe<ResolversTypes['Pairing']>, ParentType, ContextType, RequireFields<MutationSendPairingEmailArgs, 'pairingId'>>;
  subscribeToNewsletter?: Resolver<Maybe<ResolversTypes['NewsletterSubscription']>, ParentType, ContextType, RequireFields<MutationSubscribeToNewsletterArgs, 'email'>>;
  updateRegistration?: Resolver<ResolversTypes['Registration'], ParentType, ContextType, RequireFields<MutationUpdateRegistrationArgs, never>>;
  validateRegistration?: Resolver<Maybe<ResolversTypes['Registration']>, ParentType, ContextType, RequireFields<MutationValidateRegistrationArgs, 'id'>>;
  waitlistRegistration?: Resolver<Maybe<ResolversTypes['Registration']>, ParentType, ContextType, RequireFields<MutationWaitlistRegistrationArgs, 'registrationId'>>;
  waitlistRegistrationsInActivity?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType, RequireFields<MutationWaitlistRegistrationsInActivityArgs, 'activityId'>>;
};

export type NewsletterSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterSubscription'] = ResolversParentTypes['NewsletterSubscription']> = {
  created?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PairingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Pairing'] = ResolversParentTypes['Pairing']> = {
  activity?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType, RequireFields<PairingActivityArgs, never>>;
  created?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  emailSent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  learnerRegistration?: Resolver<ResolversTypes['Registration'], ParentType, ContextType>;
  teacherRegistration?: Resolver<ResolversTypes['Registration'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PairingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PairingResponse'] = ResolversParentTypes['PairingResponse']> = {
  activity?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  activity?: Resolver<Maybe<ResolversTypes['Activity']>, ParentType, ContextType, RequireFields<QueryActivityArgs, 'activityId'>>;
  pairing?: Resolver<Maybe<ResolversTypes['Pairing']>, ParentType, ContextType, RequireFields<QueryPairingArgs, 'id'>>;
  pairings?: Resolver<Maybe<Array<Maybe<ResolversTypes['Pairing']>>>, ParentType, ContextType>;
  registration?: Resolver<Maybe<ResolversTypes['Registration']>, ParentType, ContextType, RequireFields<QueryRegistrationArgs, 'id'>>;
  registrations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Registration']>>>, ParentType, ContextType>;
  registrationsForActivity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryRegistrationsForActivityArgs, 'activityId'>>;
  subscriptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['NewsletterSubscription']>>>, ParentType, ContextType>;
};

export type RegistrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Registration'] = ResolversParentTypes['Registration']> = {
  activity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  birthYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['genderType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isLanguageVolunteer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMember?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWaitlisted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  province?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  surname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  teacherGender?: Resolver<Maybe<Array<ResolversTypes['genderType']>>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['registrationType'], ParentType, ContextType>;
  unsubscriptionToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Timestamp'], any> {
  name: 'Timestamp';
}

export type Resolvers<ContextType = any> = {
  Activity?: ActivityResolvers<ContextType>;
  ContactMessage?: ContactMessageResolvers<ContextType>;
  DeletePairingResponse?: DeletePairingResponseResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NewsletterSubscription?: NewsletterSubscriptionResolvers<ContextType>;
  Pairing?: PairingResolvers<ContextType>;
  PairingResponse?: PairingResponseResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Registration?: RegistrationResolvers<ContextType>;
  Timestamp?: GraphQLScalarType;
};

